// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"f1079cd0","222":"fb008567","542":"796f7c37","790":"53a1a432"}[chunkId] + ".chunk.css";
};